<template>
  <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
    <g id="Layer_1">
      <title>Layer 1</title>
      <ellipse
        id="svg_5"
        stroke-width="0"
        ry="18"
        rx="18"
        cy="18"
        cx="18"
        stroke="#000"
        fill="currentColor"
      />
      <g>
        <path
          d="m6.8963,23.64525l5.46012,-5.64663l-5.46012,-5.64667l3.12074,-3.227l8.58152,8.87368l-8.58152,8.87643"
          stroke-width="0"
          fill="#ffffff"
        />
        <path
          d="m18.77644,23.64525l5.46012,-5.64663l-5.46012,-5.64667l3.12074,-3.227l8.58152,8.87368l-8.58152,8.87643"
          stroke-width="0"
          fill="#ffffff"
        />
      </g>
    </g>
  </svg>
</template>
